<i class="fa" [ngClass]="active ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
